{
	"paths": {
		"email": "Correo electrónico",
		"password": "Contraseña",
		"newPassword": "Nueva Contraseña",
		"repeatPassword": "Repetir Contraseña",
		"username": "Nombre de usuario",
		"firstName": "Nombre",
		"lastName": "Apellido",
		"emailOrUsername": "Correo electrónico o Nombre de usuario",
		"telephone": "Teléfono"
	},
	"errors": {
		"at_least_numbers_with_value": "Debe contener al menos {{ minimum }} número",
		"at_least_numbers_with_path": "{{ path }} debe contener al menos {{ minimum }} número",
		"at_least_special_characters_with_value": "Debe contener al menos {{ minimum }} caracteres especiales",
		"at_least_special_characters_with_path": "{{ path }} debe contener al menos {{ minimum }} caracteres especiales",
		"only_letters_numbers_underscores": "Solo se permiten letras, números y guiones bajos"
	}
}
